import { Box, Divider, Typography } from "@mui/material";
import { MarginTop40Box, PageHeaderTitle, SearchButton, SearchInput } from "../../atoms";
import { SearchContainer } from "../../molecules";
import { useNavigate } from "react-router-dom";

type SearchSectionProps = { handleSearch; filter };

export const FilterSection = ({ handleSearch, filter }: SearchSectionProps) => {
  const navigate = useNavigate();
  return (
    <MarginTop40Box>
      <SearchContainer>
        <div style={{ display: "flex", gap: "1.5625rem", alignItems: "center" }}>
          <PageHeaderTitle title="Admins" />
        </div>
        <Box
          sx={{
            display: "flex",
            gap: "1.25rem",
            alignItems: "center",
          }}
        >
          <SearchInput value={filter.search} onChange={(s) => handleSearch({ search: s, page: 1 })} />
          <SearchButton onClick={() => navigate("add")} label="Add New Admin" />
        </Box>
      </SearchContainer>
    </MarginTop40Box>
  );
};
